'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _authors = require('../actions/authors');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchAuthors),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchAuthorsRequest);

function fetchAuthors() {
    var response;
    return regeneratorRuntime.wrap(function fetchAuthors$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/authors');

                case 3:
                    response = _context.sent;
                    _context.next = 6;
                    return (0, _effects.put)(_authors.actionCreators.fetchAuthorsSucceeded(response.data));

                case 6:
                    _context.next = 12;
                    break;

                case 8:
                    _context.prev = 8;
                    _context.t0 = _context['catch'](0);
                    _context.next = 12;
                    return (0, _effects.put)(_authors.actionCreators.fetchAuthorsFailed());

                case 12:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 8]]);
}

function fetchAuthorsRequest() {
    return regeneratorRuntime.wrap(function fetchAuthorsRequest$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(_authors.actionTypes.FETCH_AUTHORS_REQUEST, fetchAuthors);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

exports.default = [fetchAuthorsRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvZWZmZWN0cy9hdXRob3JzLmpzIl0sIm5hbWVzIjpbImZldGNoQXV0aG9ycyIsImZldGNoQXV0aG9yc1JlcXVlc3QiLCJyZXF1ZXN0IiwicmVzcG9uc2UiLCJhY3Rpb25DcmVhdG9ycyIsImZldGNoQXV0aG9yc1N1Y2NlZWRlZCIsImRhdGEiLCJmZXRjaEF1dGhvcnNGYWlsZWQiLCJhY3Rpb25UeXBlcyIsIkZFVENIX0FVVEhPUlNfUkVRVUVTVCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7O0FBQ0E7O0FBQ0E7O21EQUVVQSxZO29EQVdBQyxtQjs7QUFYVixTQUFVRCxZQUFWO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSwyQkFHK0IsbUJBQUtFLFlBQUwsRUFBYyxLQUFkLEVBQXFCLFVBQXJCLENBSC9COztBQUFBO0FBR2NDLDRCQUhkO0FBQUE7QUFBQSwyQkFLYyxrQkFBSUMsd0JBQWVDLHFCQUFmLENBQXFDRixTQUFTRyxJQUE5QyxDQUFKLENBTGQ7O0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsMkJBT2Msa0JBQUlGLHdCQUFlRyxrQkFBZixFQUFKLENBUGQ7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBV0EsU0FBVU4sbUJBQVY7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsMkJBQ1UseUJBQVdPLHFCQUFZQyxxQkFBdkIsRUFBOENULFlBQTlDLENBRFY7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O2tCQUllLENBQ1hDLG1CQURXLEMiLCJmaWxlIjoiYXV0aG9ycy5qcyIsInNvdXJjZVJvb3QiOiIvc3JjIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY2FsbCwgcHV0LCB0YWtlTGF0ZXN0IH0gZnJvbSAncmVkdXgtc2FnYS9lZmZlY3RzJztcbmltcG9ydCB7IGFjdGlvblR5cGVzLCBhY3Rpb25DcmVhdG9ycyB9IGZyb20gJy4uL2FjdGlvbnMvYXV0aG9ycyc7XG5pbXBvcnQgeyByZXF1ZXN0IH0gZnJvbSAnLi4vYXBpJztcblxuZnVuY3Rpb24qIGZldGNoQXV0aG9ycygpIHtcblxuICAgIHRyeSB7XG4gICAgICAgIGNvbnN0IHJlc3BvbnNlID0geWllbGQgY2FsbChyZXF1ZXN0LCAnZ2V0JywgJy9hdXRob3JzJyk7XG5cbiAgICAgICAgeWllbGQgcHV0KGFjdGlvbkNyZWF0b3JzLmZldGNoQXV0aG9yc1N1Y2NlZWRlZChyZXNwb25zZS5kYXRhKSk7XG4gICAgfSBjYXRjaCAoZXJyb3IpIHtcbiAgICAgICAgeWllbGQgcHV0KGFjdGlvbkNyZWF0b3JzLmZldGNoQXV0aG9yc0ZhaWxlZCgpKTtcbiAgICB9XG59XG5cbmZ1bmN0aW9uKiBmZXRjaEF1dGhvcnNSZXF1ZXN0KCkge1xuICAgIHlpZWxkIHRha2VMYXRlc3QoYWN0aW9uVHlwZXMuRkVUQ0hfQVVUSE9SU19SRVFVRVNULCBmZXRjaEF1dGhvcnMpO1xufVxuXG5leHBvcnQgZGVmYXVsdCBbXG4gICAgZmV0Y2hBdXRob3JzUmVxdWVzdFxuXTsiXX0=


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/authors.js
// module id = 2219
// module chunks = 0